import { useDealershipSettings } from '@/modules/crm/hooks/useDealershipSettings';

/**
 * Feature flag hook for AI capabilities.
 *
 * Phase 39+: gating collapses to `ai_enabled` only. Provider API keys are
 * platform-owned (`platform_ai_settings` in landlord DB) and not visible to
 * tenants — so the old `openrouter_key_last4 || perplexity_key_last4` check
 * is gone. Instead, key availability is a platform concern: if keys aren't
 * configured at the platform level and a tenant tries to trigger AI, the
 * dispatcher returns 503 with a clear error which the AI card surfaces
 * in-place (see AiSpecDiffTable / AIDescriptionCard).
 *
 * Returned flags:
 * - `isEnabled`   — tenant has toggled AI on for their dealership
 * - `canUseAI`    — alias for `isEnabled` (preserved for call-sites that
 *                   still destructure it — same meaning post-Phase 39)
 * - `disabledReason` — tooltip text for disabled buttons
 */
export function useAiFeatureFlag() {
  const { data: settings, isLoading } = useDealershipSettings();

  const isEnabled = settings?.ai_enabled === true;

  return {
    isEnabled,
    canUseAI: isEnabled,
    isLoading,
    disabledReason: isEnabled ? undefined : undefined,
  };
}
